<template>
    <div>
        <!-- TEXT TO GIFT CARDS -->
        <div v-if="cardId === 1">
            <p class="font-weight-bold">Your experience is important to us</p>
            <div class="mb-4">
              <p>Let us know how this gift affected you.</p>
                <ul>
                <li>Is this gift beneficial to you, and how?</li>
                <li>Will you use this gift to serve your clients and family better?</li>
                <li>Can you implement this in your work to more value, and how?</li>
                </ul>
            <p>Thank you for your feedback. This way, we can create gifts for you in the future that serve you even better.</p>
          </div>            
        </div>

        <!-- TEXT TO GC ANALYSIS -->
        <div v-if="cardId === 3">
          <p class="font-weight-bold">Share a testimonial</p>
          <div class="mb-4">
            <p>Most aromatherapists struggle when looking for a good solution for relable aromatherapy information and tools. You can help them find us by giving a testimonial.</p>

            <p>A testimonial can be explained as what it was like to use different Dropsmart services and how we performed for you. This information would be appreciated since it allows people to see who we are and what we do.</p>

            <p>This is really easy to do and it will not take much time but it does have a strong impact. Simply share the best thing you like about these Premium extras and how Dropsmart helped you out.</p>
            <p>Thank you.</p>
          </div>
        </div>

        <!-- TEXT TO MODERN COSMETICS -->
        <div v-if="cardId === 4">
          <p class="font-weight-bold">Share a testimonial</p>
          <div class="mb-4">
            <p>Most aromatherapists struggle when looking for a good solution for relable aromatherapy information and tools. You can help them find us by giving a testimonial.</p>

            <p>A testimonial can be explained as what it was like to use different Dropsmart services and how we performed for you. This information would be appreciated since it allows people to see who we are and what we do.</p>

            <p>This is really easy to do and it will not take much time but it does have a strong impact. Simply share the best thing you like about these Premium extras and how Dropsmart helped you out.</p>
            <p>Thank you.</p>
          </div>
        </div>

        <!-- TEXT TO 2023 CALENDAR -->
      <div v-if="cardId === 5">
        <p class="font-weight-bold">Share a testimonial</p>
          <div class="mb-4">
            <p>Most aromatherapists struggle when looking for a good solution for relable aromatherapy information and tools. You can help them find us by giving a testimonial.</p>

            <p>A testimonial can be explained as what it was like to use different Dropsmart services and how we performed for you. This information would be appreciated since it allows people to see who we are and what we do.</p>

            <p>This is really easy to do and it will not take much time but it does have a strong impact. Simply share the best thing you like about these Premium extras and how Dropsmart helped you out.</p>
            <p>Thank you.</p>
          </div>
      </div>

      <!-- TEXT TO DRESS TO PROGRESS and Clarify to Amplify-->
      <div v-if="cardId === 6 || cardId === 10">
        <p class="font-weight-bold">Share a testimonial</p>
          <div class="mb-4">
            <p>Most aromatherapists struggle when looking for a good solution for relable aromatherapy information and tools. You can help them find us by giving a testimonial.</p>

            <p>A testimonial can be explained as what it was like to use different Dropsmart services and how we performed for you. This information would be appreciated since it allows people to see who we are and what we do.</p>

            <p>This is really easy to do and it will not take much time but it does have a strong impact. Simply share the best thing you like about these Premium extras and how Dropsmart helped you out.</p>
            <p>Thank you.</p>
          </div>
      </div>

      <!-- TEXT TO DRESS TO PROGRESS -->
      <div v-if="cardId === 11">
        <p class="font-weight-bold">Share a testimonial</p>
          <div class="mb-4">
            <p>Most aromatherapists struggle when looking for a good solution for relable aromatherapy information and tools. You can help them find us by giving a testimonial.</p>

            <p>A testimonial can be explained as what it was like to use different Dropsmart services and how we performed for you. This information would be appreciated since it allows people to see who we are and what we do.</p>

            <p>This is really easy to do and it will not take much time but it does have a strong impact. Simply share the best thing you like about these Premium extras and how Dropsmart helped you out.</p>
            <p>Thank you.</p>
          </div>
      </div>

    </div>
</template>

<script>
export default {
  name: "PremiumTextRightModal",
  mounted() {
    this.cardId = parseInt(this.$route.query.id)
  },
  data() {
    return {
        cardId: 0,
    }
  }
}
</script>
